import { Navigate } from "react-router-dom";
import { useClientAuth } from "../../utils/useAuth";

const ClientProtectedRoute = ({ children }) => {
  const { isClient } = useClientAuth();
  if (!isClient) {
    return <Navigate to={"/client/auth"} replace />;
  }

  return children;
};

export default ClientProtectedRoute;
